import { render, staticRenderFns } from "./SidebarFilterProductPromotion.vue?vue&type=template&id=49916133&scoped=true"
import script from "./SidebarFilterProductPromotion.vue?vue&type=script&lang=js"
export * from "./SidebarFilterProductPromotion.vue?vue&type=script&lang=js"
import style0 from "./SidebarFilterProductPromotion.vue?vue&type=style&index=0&id=49916133&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49916133",
  null
  
)

export default component.exports